export default "__VITE_ASSET__C3rhqjYZ__"